import { render, staticRenderFns } from "./MenuSchedules.vue?vue&type=template&id=19108dc7&scoped=true"
import script from "./MenuSchedules.vue?vue&type=script&lang=ts"
export * from "./MenuSchedules.vue?vue&type=script&lang=ts"
import style0 from "./MenuSchedules.vue?vue&type=style&index=0&id=19108dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19108dc7",
  null
  
)

export default component.exports